import { useEffect, useState } from "react";

import DemoOne from "@/components/demo";
import { languageMeta, translations, type Language } from "@/lib/i18n";

function App() {
  const [language, setLanguage] = useState<Language>("he");
  const copy = translations[language];
  const direction = languageMeta[language].dir;

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = direction;
    document.title = copy.documentTitle;
  }, [copy.documentTitle, direction, language]);

  return (
    <div
      className="min-h-screen bg-background text-foreground transition-colors"
      dir={direction}
      lang={language}
    >
      <DemoOne
        copy={copy}
        direction={direction}
        language={language}
        onLanguageChange={() =>
          setLanguage((currentLanguage) =>
            currentLanguage === "he" ? "en" : "he",
          )
        }
      />
    </div>
  );
}

export default App;
